import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CalendarCheck, AlertTriangle, ListTodo, User } from "lucide-react";

export default function TodaySummary() {
  const [tasks, setTasks] = useState([]);
  useEffect(() => { api.get("/board/tasks").then((r) => setTasks(r.data)).catch(() => {}); }, []);

  const today = new Date().toISOString().slice(0, 10);
  const open = tasks.filter((t) => t.status !== "done");
  const dueToday = open.filter((t) => t.due_date === today);
  const overdue = open.filter((t) => t.due_date && t.due_date < today);

  const stats = [
    { label: "Due today", value: dueToday.length, Icon: CalendarCheck, cls: "text-[var(--accent)]" },
    { label: "Overdue", value: overdue.length, Icon: AlertTriangle, cls: "text-[#c0392b]" },
    { label: "Open tasks", value: open.length, Icon: ListTodo, cls: "text-[var(--text-2)]" },
  ];

  const spotlight = [...overdue, ...dueToday].slice(0, 4);

  return (
    <div data-testid="today-summary" className="border border-[var(--line)] bg-white p-5 mb-8">
      <p className="label-mono text-[var(--text-2)] mb-4">My tasks today</p>
      <div className="grid grid-cols-3 gap-3">
        {stats.map((s) => (
          <div key={s.label} data-testid={`today-stat-${s.label.replace(/\s+/g, "-").toLowerCase()}`} className="border border-[var(--line)] bg-[#f9f9f7] p-4">
            <s.Icon className={`w-5 h-5 ${s.cls}`} />
            <p className="text-3xl font-serif mt-2 leading-none">{s.value}</p>
            <p className="text-xs text-[var(--text-2)] mt-1">{s.label}</p>
          </div>
        ))}
      </div>
      {spotlight.length > 0 && (
        <div className="mt-4 space-y-2">
          {spotlight.map((t) => {
            const late = t.due_date && t.due_date < today;
            return (
              <div key={t.id} data-testid={`today-task-${t.id}`} className="flex items-center gap-3 text-sm border border-[var(--line)] bg-[#f9f9f7] px-3 py-2">
                <span className={`w-2 h-2 rounded-full ${late ? "bg-[#FF6B6B]" : "bg-[var(--accent)]"}`} />
                <span className="flex-1 truncate">{t.title}</span>
                <span className="flex items-center gap-1 text-xs text-[var(--text-2)] shrink-0"><User className="w-3 h-3" /> {t.assignee || "Unassigned"}</span>
                {late && <span className="text-[10px] uppercase tracking-wider text-[#c0392b] shrink-0">Overdue</span>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
